import api from '@/api';
import { API_BASE_URL } from '..';
import {
  StoneAccount,
  StoneAccountCreateRequest,
  StoneAccountUpdateRequest,
} from './stoneAccount.types';

const CONTROLLER = `${API_BASE_URL}/stoneAccount`;

export default {
  async list() {
    const result = (await api.get(CONTROLLER, null)) as unknown;
    return result as StoneAccount[];
  },

  async detail(id?: number) {
    const result = (await api.get(`${CONTROLLER}/${id}`, null)) as unknown;
    return result as StoneAccount;
  },

  async detailByCompany(companyId?: number) {
    const result = (await api.get(
      `${CONTROLLER}/company/${companyId}`,
      null,
    )) as unknown;
    return result as StoneAccount;
  },

  async create(data: StoneAccountCreateRequest) {
    const result = (await api.post(CONTROLLER, data, null)) as unknown;
    return result as StoneAccount;
  },

  async update({ id, ...data }: StoneAccountUpdateRequest) {
    const result = (await api.put(
      `${CONTROLLER}/${id}`,
      data,
      null,
    )) as unknown;
    return result as StoneAccount;
  },

  async remove(id: number) {
    const result = (await api.remove(
      `${CONTROLLER}/${id}`,
      {},
      null,
    )) as unknown;
    return result as void;
  },
};
